import React from "react";
import Sidebar from "../dashboard/Sidebar";
import Header from "../dashboard/Header";
import { useNavigate } from "react-router-dom";
import { BsXCircleFill, BsArrowRight, BsArrowLeft } from "react-icons/bs";
import "./BillingResult.css";

export default function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="billing-result-wrap">
          <div className="billing-result-card">
            <div className="result-icon result-icon-cancel">
              <BsXCircleFill />
            </div>
            <h2>Checkout Cancelled</h2>
            <p>No changes were made to your account. You can restart the checkout whenever you're ready.</p>
            <div className="result-actions">
              <button className="btn-result-primary" onClick={() => navigate("/plans")}>
                Try Again <BsArrowRight />
              </button>
              <button className="btn-result-secondary" onClick={() => navigate("/billing")}>
                <BsArrowLeft /> Back to Billing
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
